/**
 * Parsea un número en formato español (es-VE) a Number
 * Soporta formatos como "32.539,00", "325,39", "325.39"
 * @param {string|number} input - Valor a parsear
 * @returns {number} - Número parseado o 0 si es inválido
 */
export function parseEsNumber(input) {
  if (input === null || input === undefined) return 0;
  if (typeof input === "number") return isNaN(input) ? 0 : input;
  const str = String(input).trim();
  if (!str) return 0;
  
  // Permitir que venga con prefijos como "$" o "Bs.", espacios, etc.
  // Dejamos solo dígitos y separadores decimales/miles.
  const cleaned = str.replace(/[^0-9.,-]/g, "");

  // Soportar:
  // - "32.539,00" (es-VE: miles con '.', decimales con ',')
  // - "325,39" (decimales con ',')
  // - "325.39" (backend puede enviar decimales con '.')
  const hasDot = cleaned.includes(".");
  const hasComma = cleaned.includes(",");

  let normalized = cleaned;
  if (hasDot && hasComma) {
    const lastDot = cleaned.lastIndexOf(".");
    const lastComma = cleaned.lastIndexOf(",");
    if (lastComma > lastDot) {
      // 32.539,00 -> 32539.00
      normalized = cleaned.replace(/\./g, "").replace(/,/g, ".");
    } else {
      // 32,539.00 -> 32539.00
      normalized = cleaned.replace(/,/g, "");
    }
  } else if (hasComma) {
    // 325,39 -> 325.39
    normalized = cleaned.replace(/,/g, ".");
  } else if (hasDot) {
    // 325.39 -> 325.39 (asumimos '.' decimal si es el único separador)
    normalized = cleaned;
  }

  const n = Number(normalized);
  return isNaN(n) ? 0 : n;
}
